/**
 * Cache persistente: total de parcelas por título (Sienge installmentsNumber).
 * Valor estável por billId — evita refetch ao reabrir o modal e complementa o mapa agregado.
 */

const STORAGE_KEY = "pbisemog_installment_totals_v1";
/** Limite defensivo (localStorage); remove entradas mais antigas por ordem de chave. */
const MAX_KEYS = 8000;

type Store = Record<string, number>;

function loadStore(): Store {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw) as Store;
    return o && typeof o === "object" && !Array.isArray(o) ? o : {};
  } catch {
    return {};
  }
}

function saveStore(o: Store): void {
  try {
    const keys = Object.keys(o);
    if (keys.length > MAX_KEYS) {
      keys.sort();
      for (let i = 0; i < keys.length - MAX_KEYS; i++) delete o[keys[i]];
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(o));
  } catch {
    /* quota / modo privado */
  }
}

/** Lê do cache só os billIds pedidos (chaves normalizadas). */
export function readInstallmentTotalsCacheForBillIds(billIds: string[]): Map<string, number> {
  const store = loadStore();
  const out = new Map<string, number>();
  for (const raw of billIds) {
    const id = String(raw ?? "").trim();
    if (!id) continue;
    const n = Number(store[id]);
    if (Number.isFinite(n) && n > 0) out.set(id, Math.floor(n));
  }
  return out;
}

/** Mescla totais no localStorage (novos ou atualizados). */
export function mergeInstallmentTotalsIntoCache(map: Map<string, number> | Record<string, number>): void {
  const o = loadStore();
  const entries =
    map instanceof Map ? Array.from(map.entries()) : Object.entries(map as Record<string, number>);
  for (const [k, v] of entries) {
    const id = String(k ?? "").trim();
    const n = Number(v);
    if (!id || !Number.isFinite(n) || n <= 0) continue;
    o[id] = Math.floor(n);
  }
  saveStore(o);
}
